<template>
  <div class="epidemiological-situation">
    <div class="row">
      <div class="columns small-12 large-8">
        <h1 class="display-h3">{{ page.headline }}</h1>
        <p>{{ page.content }}</p>
        <p class="small" v-if="updated_at !== null">Ostatnia aktualizacja sytuacji epidemiologicznej: {{ updated_at }} r.</p>
      </div>
      <div class="columns small-12 large-4 margin-bt-3" aria-hidden="true">
        <PlaneAnimation />
      </div>
    </div>
    <div v-if="0 === 1" class="row">
      <div class="columns small-12 large-4">
        <h2 class="display-h3">Wybierz kraj</h2>
        <div class="field">
          <label for="country" class="field__label">Wybierz kraj</label>
          <select id="country" v-model="selected">
            <option disabled selected :value="null">- wybierz kraj -</option>
            <option v-for="(country, index) in data" :key="index" :value="country">{{ country.title.rendered }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row content" v-if="selected !== null">
      <div class="columns small-12 large-8 margin-bt-3">
        <div class="content" v-html="selected.content.rendered"></div>
        <div class="disease" v-show="selected.disease.length">
          <div v-for="(id, index) in selected.disease" :key="index">
            <p><strong>{{ disease[id]['name'] }}</strong></p>
            <p v-html="disease[id]['description']"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="belt">
      <div class="row">
        <div class="columns small-12 large-6" v-html="page.table"></div>
        <div class="columns small-12 large-5 large-offset-1 text-center">
          <a :href="page.href" class="btn" target="_blank" rel="nofollow noopener">{{ page.button }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import PlaneAnimation from '@/components/animations/PlaneAnimation';
import { HTTP } from '@/utils/http-common';
import { dealWithHttpErrors } from '@/mixins/deal-with-http-errors';

export default Vue.extend({
  mixins: [
    dealWithHttpErrors,
  ],
  components: {
    PlaneAnimation,
  },
  data() {
    return {
      selected: null,
      data: [
        {
          title: {
            rendered: null,
          },
        },
      ],
      page: {
        headline: null,
        content: null,
        table: null,
        button: null,
        href: false,
      },
      updated_at: '',
      disease: [],
    };
  },
  created() {
    HTTP.get('wp/v2/sytuacja?per_page=200&orderby=title&order=asc').then((response) => {
      this.data = response.data;
      const sorted = Object.assign([], this.data).sort((post1, post2) => {
        const a = new Date(post1.modified_gmt);
        const b = new Date(post2.modified_gmt);
        if (a > b) {
          return -1;
        }
        if (a < b) {
          return 1;
        }
        return 0;
      });
    }).catch((e) => {
      this.handleError(e.response);
    });

    HTTP.get('wp/v2/pages/263').then((response) => {
      this.page = response.data.acf;
      this.updated_at = new Date(response.data.modified_gmt).toLocaleDateString('pl-PL');
    }).catch((e) => {
      this.handleError(e.response);
    });

    HTTP.get('wp/v2/disease').then((response) => {
      response.data.forEach((item) => {
        this.disease[item.id] = {
          name: item.name,
          description: item.description,
        };
      });
    }).catch((e) => {
      this.handleError(e.response);
    });
  },
});
</script>

<style lang="scss">
.epidemiological-situation {
  p {
    &.small {
      font-size: em(15px);
    }
  }
  .content {
    ul, ol {
      font-size: em(18px);
      list-style: none;
      padding-left: 15px;
      li {
        line-height: 30px;
        &:before {
          content: "\2022";
          color: #000;
          font-weight: bold;
          display: inline-block;
          width: 1em;
          margin-left: -1em;
        }
      }
      ul, ol {
        font-size: 1em;
        padding-left: 30px;
      }
    }
  }
  .field {
    width: 100%;
    display: block;
    margin-bottom: 30px;
    &__label {
      width: 100%;
      display: block;
      font-size: em(15px);
      font-weight: 600;
      margin-bottom: 10px;
      position: absolute;
      left: -99999px;
    }
    input, select {
      width: 100%;
      display: block;
      background: transparent;
      border: none;
      border-bottom: 1px solid $red;
      padding: 5px 0;
      font-size: em(15px);
      border-radius: 0;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      color: #000;
      font-weight: 600;
    }
  }
  .belt {
    padding: 40px 0;
    @include desktop {
      padding: 80px 0;
    }
    background: $bg-color;
    .row {
      align-items: center;
      h3 {
        margin: 0 0 15px 0;
        @include desktop {
          margin: 0;
        }
      }
    }
  }
  .disease {
    white-space: pre-line;
  }
}
</style>
